import { Job } from "@interfaces/career"
import { PaginationData } from "@interfaces/misc"
import JobsRepositories from "@lib/api/repositories/jobs.repositories"
import CareerListPage from "@modules/career-list/CareerListPage"
import { GetServerSideProps } from "next"

export const getServerSideProps: GetServerSideProps = async () => {
  const jobs = new JobsRepositories()

  try {
    const res = await jobs.getRawJobs()

    if (res.ok) {
      const response = await res.json()
      const result = response.result as PaginationData<Job>

      return {
        props: {
          initialData: result.data,
          categoryDetail: null,
        },
      }
    }

    return {
      props: {
        initialData: [],
        categoryDetail: null,
      },
    }
  } catch (e: any) {
    console.log(e)

    return {
      props: {
        initialData: [],
        categoryDetail: null,
      },
    }
  }
}

export default CareerListPage
